import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import { generateAxiosInstanceInstitute } from '../hooks/useAuthorizedRequestForInstitute';
import { generateAxiosInstanceSection } from '../hooks/useAuthorizedRequestForSection';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../components/ModalsCommonFunctions';
import { CModal } from '@coreui/react';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../components/Navigation';
import Pagination from '../components/Pagination';
import VidyaUpasnaLogo from '../assets/VidyaUpasna.jpg';
import separator_line from '../assets/separator_line.png';
import { GeneratePdf } from '../components/GeneratePdf';

const AppSubscriptionCompleteStudentList = () => {
    const authorizedAxios = generateAxiosInstance();
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute();
    const authorizedAxiosSection = generateAxiosInstanceSection();
    let instituteMasterId = process.env.REACT_APP_REGISTER_INSTITUTE_ID;

    const initialFormState = {
        instituteMasterId: instituteMasterId,
        sectionMasterId: '',
        academicYearMasterId: '',
        instituteGradeMasterId: '',
        instituteDivisionMasterId: '',
        list: "complete",
    }

    const [studentData, setStudentData] = useState(initialFormState);
    const [studentList, setStudentList] = useState([]);

    const [sectionList, setSectionList] = useState([]);
    const [gradeList, setGradeList] = useState([])
    const [divisionList, setDivisionList] = useState([])
    const [yearList, setYearList] = useState([])

    const [paymentDetails, setPaymentDetails] = useState([])
    const [visiblePaymentDetails, setVisiblePaymentDetails] = useState()
    const [planList, setPlanList] = useState([])


    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);

    const [saveId, setSaveId] = useState(null);

    const [userNameSort, setUserNameSort] = useState(null);
    const [emailSort, setEmailSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["userUniqueId", "email"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleNavigate = (route) => {
        navigate(route);
    };

    const getPlanList = async () => {
        try {
            const apiUrl = "/subscription";
            const response = await authorizedAxios.get(apiUrl);
            setPlanList(response.data.data);
        } catch (error) {
            const errorMsg = error?.data?.message || "Something went wrong!";
            console.log("Fetching error data: ", errorMsg);
        }
    }

    useEffect(() => {
        // getStudentList();
        getPlanList();
        getSectionList();
    }, [])

    useEffect(() => {
        if (studentData.sectionMasterId) {
            getStudentList();
        }
    }, [studentData]);

    const getApiUrl = () => {
        if (studentData.sectionMasterId) {
            let apiUrl = `/get-app-subscriber-list?`;
            if (studentData.instituteMasterId !== '') {
                apiUrl += `instituteMasterId=${studentData.instituteMasterId}&`;
            }
            if (studentData.sectionMasterId !== '') {
                apiUrl += `sectionMasterId=${studentData.sectionMasterId}&`;
            }
            if (studentData.academicYearMasterId !== '') {
                apiUrl += `academicYearMasterId=${studentData.academicYearMasterId}&`;
            }
            if (studentData.instituteGradeMasterId !== '') {
                apiUrl += `instituteGradeMasterId=${studentData.instituteGradeMasterId}&`;
            }
            if (studentData.instituteDivisionMasterId !== '') {
                apiUrl += `instituteDivisionMasterId=${studentData.instituteDivisionMasterId}&`;
            }
            if (studentData.list !== '') {
                apiUrl += `list=${studentData.list}&`;
            }

            apiUrl = apiUrl.replace(/&$/, '');
            return apiUrl;
        }
    }

    const getStudentList = async () => {
        try {
            setLoading(true);
            const response = await authorizedAxios.get(getApiUrl());
            setStudentList(response.data.result);
        } catch (error) {
            setStudentList([]);
            const errorMsg = error?.data?.message || 'Something went wrong!';
            console.error('Error fetching data:', errorMsg);
        } finally {
            setLoading(false);
        }
    }


    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getStudentList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null && studentData.sectionMasterId) {
            setCurrPage(1);
            setStudentList(await searchArray("A", getApiUrl(), searchKeys, searchValue.trim()));
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(studentList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])


    useEffect(() => {
        setTotalPages(Math.ceil(studentList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > studentList.length) {
            endIndex = studentList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(studentList.slice(startIndex, endIndex));
    }, [studentList, currPage, itemsPerPage])

    const getSectionList = () => {
        const apiUrl = `/get-section?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setSectionList(response.data.result)
            })
            .catch(error => {
                setSectionList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getYearList = (sectionMasterId) => {
        let apiUrl = `/get-sections-academic-years?`;
        if (sectionMasterId) {
            apiUrl += `sectionMasterId=${sectionMasterId}`;
        }
        apiUrl = apiUrl.replace(/&$/, '');
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setYearList(response.data.data)
            })
            .catch(error => {
                setYearList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getGradeList = (sectionMasterId) => {
        const apiUrl = `/get-app-register-section-grades?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setGradeList(response.data.result)
            })
            .catch(error => {
                setGradeList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSectionChange = (e) => {
        const { name, value } = e.target;
        setStudentData((prevData) => {
            return {
                ...prevData,
                [name]: value,
                instituteDivisionMasterId: '',
            }
        });

        getYearList(value);
        getGradeList(value);
    }

    const handleGradeChange = (e) => {
        const { name, value } = e.target;
        setStudentData((prevData) => {
            return {
                ...prevData,
                instituteDivisionMasterId: '',
                [name]: value
            }
        })

        const apiUrl = `/grade-wise-division?instituteMasterId=${instituteMasterId}&instituteGradeMasterId=${value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setDivisionList(response.data.result);
            })
            .catch(error => {
                setDivisionList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e) => {
        setStudentData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }

    const handleInputReset = () => {
        setStudentData(initialFormState)
        // setPaymentList([])

        // setSectionNameSort(null);
        // setTeacherEmailSort(null);
        // setStudentEmailSort(null);
        // setTeacherNameSort(null);
        // setStudentNameSort(null);
        // setAcademicYearSort(null);
        // setDssTitleSort(null);
        // setAmountSort(null);
    }


    useEffect(() => {
        if (userNameSort == true || userNameSort == false) {
            setEmailSort(null);
        }
    }, [userNameSort])

    useEffect(() => {
        if (emailSort == true || emailSort == false) {
            setUserNameSort(null);
        }
    }, [emailSort])


    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>App Subscription Report</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fas fa-file-invoice-dollar"></i>App Subscription Report</b></h4>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="sectionMasterId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Section</label>
                                                    <select class="form-select" aria-label="Default select example" name='sectionMasterId' onChange={handleSectionChange} value={studentData.sectionMasterId} >
                                                        <option selected value={''} disabled>Select Section</option>
                                                        {
                                                            sectionList?.map((section) => {
                                                                return <option value={section.id}>{section.sectionName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Academic Year :</label>
                                                    <select class="form-select" aria-label="Default select example" name='academicYearMasterId' onChange={handleInputChange} value={studentData.academicYearMasterId}>
                                                        <option selected value={''} disabled>Select Academic Year</option>
                                                        {
                                                            yearList?.map((list) => {
                                                                return <option value={list?.academicYearMasterDetails?.id}>{list?.academicYearMasterDetails?.yearName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Class :</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteGradeMasterId' onChange={handleGradeChange} value={studentData.instituteGradeMasterId}>
                                                        <option selected value={''} disabled>Select Class</option>
                                                        {
                                                            gradeList?.map((grade) => {
                                                                return <option value={grade.instituteGradeMasterId}>{grade.instituteGradeMasterDetails.gradeName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Division :</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteDivisionMasterId' onChange={handleInputChange} value={studentData.instituteDivisionMasterId}>
                                                        <option selected value={''} disabled>Select Division</option>
                                                        {
                                                            divisionList?.map((division) => {
                                                                return <option value={division.id}>{division.divisionName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        <button className="btn btn-danger delete_icon" type="button" style={{ marginRight: "20px" }} onClick={handleInputReset}>Reset</button>
                                                    </div>
                                                </div>
                                            </div>

                                            {!!studentData.sectionMasterId &&

                                                <div className='row'>
                                                    <div className="separator"></div>
                                                    <div className="d-grid gap-2 mt-2">
                                                        {displayedData.length > 0 ?
                                                            <>
                                                                {/* <div className='search_btn_row'>
                                                                    <input
                                                                        className="form-control mr-sm-2"
                                                                        type="Search"
                                                                        placeholder="Search"
                                                                        value={searchValue}
                                                                        onChange={handleEmptySearch}
                                                                        onKeyDown={(event) => {
                                                                            if (event.key === 'Enter') {
                                                                                handleSearch();
                                                                            }
                                                                        }}
                                                                    />
                                                                    <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                                </div> */}
                                                                <GeneratePdf id="AppSubscriptionReport" title={studentList} headerTitle={"Vidya Upasna"} planList={planList} />
                                                                <div class="report_block" id="AppSubscriptionReport">
                                                                    <div class="heading">
                                                                        <div class="logo">
                                                                            <img src={VidyaUpasnaLogo} alt="VidyaUpasna Logo" />
                                                                        </div>
                                                                        <div class="text_center">
                                                                            <h4>Vidya Upasna</h4>
                                                                        </div>
                                                                        <div class="logo">
                                                                            <img src={"https://api.examninja.co.in/images/1705820792167-939.jpeg"} alt="VidyaUpasna Logo" />
                                                                        </div>
                                                                    </div>

                                                                    <div class="report_code text_center">
                                                                        <img src={separator_line} alt="" className="line" />
                                                                        <span className="txt">Student Subscription Report</span>
                                                                    </div>

                                                                    <div class="report_head">
                                                                        <span>Section: {displayedData[0]?.studentDetails?.sectionMasterDetails?.sectionName}</span>
                                                                        <span>Board: {displayedData[0]?.studentDetails?.sectionMasterDetails?.boardMasterDetails?.boardName}</span>
                                                                        <span>Medium: {displayedData[0]?.studentDetails?.sectionMasterDetails?.streamOrMediumMasterDetails?.streamName}</span>
                                                                    </div>

                                                                    <div class="analysis_report">
                                                                        <table>
                                                                            <thead>
                                                                                <tr>
                                                                                    <th rowSpan="2">Student Name</th>
                                                                                    <th rowSpan="2">Gender</th>
                                                                                    <th rowSpan="2">Phone</th>
                                                                                    <th rowSpan="2">Email</th>
                                                                                    <th rowSpan="2">Academic Year</th>
                                                                                    <th rowSpan="2">Grade</th>
                                                                                    <th rowSpan="2">Division</th>
                                                                                    <th colSpan="6">Payment Details</th>
                                                                                </tr>
                                                                                <tr>
                                                                                    <th>Order ID</th>
                                                                                    {/* <th>Currency</th> */}
                                                                                    <th>Receipt</th>
                                                                                    <th>Amount</th>
                                                                                    <th>Payment ID</th>
                                                                                    <th>Payment Status</th>
                                                                                    <th>Subscription Type</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {displayedData.map((data, i) =>
                                                                                    data.paymentOrderDetails.map((paymentDetail, j) => (
                                                                                        <tr key={paymentDetail.id}>
                                                                                            {j === 0 && (
                                                                                                <>
                                                                                                    <td rowSpan={data.paymentOrderDetails.length}>{data.studentDetails.studentName}</td>
                                                                                                    <td rowSpan={data.paymentOrderDetails.length}>{data.studentDetails.gender}</td>
                                                                                                    <td rowSpan={data.paymentOrderDetails.length}>{data.studentDetails.primaryContact}</td>
                                                                                                    <td rowSpan={data.paymentOrderDetails.length}>{data.studentDetails.email}</td>
                                                                                                    <td rowSpan={data.paymentOrderDetails.length}>{data.studentDetails.academicYearMasterDetails.yearName}</td>
                                                                                                    <td rowSpan={data.paymentOrderDetails.length}>{data.studentDetails.instituteGradeMasterDetails.gradeName}</td>
                                                                                                    <td rowSpan={data.paymentOrderDetails.length}>{data.studentDetails.instituteDivisionMasterDetails.divisionName}</td>
                                                                                                </>
                                                                                            )}
                                                                                            <td>{paymentDetail.order_id}</td>
                                                                                            {/* <td>{paymentDetail.currency}</td> */}
                                                                                            <td>{paymentDetail.receipt}</td>
                                                                                            <td>{paymentDetail.amount}</td>
                                                                                            <td>{paymentDetail.razor_payment_id}</td>
                                                                                            <td>{paymentDetail.payment_status ? "Paid" : "Pending"}</td>
                                                                                            <td>
                                                                                                {
                                                                                                    planList?.map(plan => {
                                                                                                        if (paymentDetail.subscription_type === plan.id) {
                                                                                                            return plan.subscriptionName
                                                                                                        }
                                                                                                    })
                                                                                                }
                                                                                            </td>
                                                                                        </tr>
                                                                                    ))
                                                                                )}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>

                                                                </div>
                                                                <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={studentList.length} />
                                                            </>
                                                            :
                                                            (<div className='row'>
                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Questions Available</th>
                                                            </div>)}
                                                    </div>
                                                </div>

                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <CModal
                backdrop="static"
                visible={visiblePaymentDetails}
                onClose={() => setVisiblePaymentDetails(false)}
                aria-labelledby="LiveDemoExampleLabel"
                className="assign-modal"
            >
                <div className="exam-detail-card">
                    <div className="payment-detail-card">
                        <header className="exam-header">
                            <h1 className="exam-title">Payment Details</h1>
                            <button type="button" className="close-btn" aria-label="Close" onClick={() => setVisiblePaymentDetails(false)} >&times;</button>
                        </header>
                        <section className="exam-info">
                            {paymentDetails?.map((paymentDetail, index) => (
                                <div className="info-group">
                                    <h2 className="group-title">Payment Detail {index + 1}</h2>
                                    <div className="info-item">
                                        <span className="label">Order ID:</span>
                                        <span className="value">{paymentDetail.order_id}</span>
                                    </div>
                                    <div className="info-item">
                                        <span className="label">Currency:</span>
                                        <span className="value">{paymentDetail.currency}</span>
                                    </div>
                                    <div className="info-item">
                                        <span className="label">Receipt:</span>
                                        <span className="value">{paymentDetail.receipt}</span>
                                    </div>
                                    <div className="info-item">
                                        <span className="label">Amount:</span>
                                        <span className="value">{paymentDetail.amount}</span>
                                    </div>
                                    <div className="info-item">
                                        <span className="label">Payment ID:</span>
                                        <span className="value">{paymentDetail.razor_payment_id}</span>
                                    </div>
                                    <div className="info-item">
                                        <span className="label">Payment Status:</span>
                                        <span className="value">{paymentDetail.payment_status ? "Paid" : "Pending"}</span>
                                    </div>
                                    <div className="info-item">
                                        <span className="label">Subscription Type:</span>
                                        <span className="value">
                                            {
                                                planList?.map(plan => {
                                                    if (paymentDetail.subscription_type === plan.id) {
                                                        return plan.subscriptionName
                                                    }
                                                })
                                            }
                                        </span>
                                    </div>
                                </div>
                            ))}
                        </section>
                    </div>
                </div>
            </CModal>

            <Footer />
        </>
    )
};

export default AppSubscriptionCompleteStudentList;